module.exports = __webpack_public_path__ + "static/media/black.0163e15f.png";